/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type JobStateStatus = "COMPLETE" | "INCOMPLETE" | "IN_PROGRESS" | "NEEDS_ATTENTION" | "PAUSED";
export type WorkflowStateType = "JOB_COMPLETED" | "JOB_CREATED" | "JOB_ITEM_COUNT" | "RUN" | "TASK";
import type { FragmentReference } from "relay-runtime";
declare export opaque type WorkflowUtils_job$ref: FragmentReference;
declare export opaque type WorkflowUtils_job$fragmentType: WorkflowUtils_job$ref;
export type WorkflowUtils_job = {|
  +id: string,
  +workflow: {|
    +id: string,
    +states: $ReadOnlyArray<{|
      +id: string,
      +name: string,
      +isRequired: ?boolean,
      +type: ?WorkflowStateType,
    |}>,
    +transitions: $ReadOnlyArray<{|
      +id: string,
      +toWorkflowState: {|
        +id: string
      |},
      +fromWorkflowState: {|
        +id: string
      |},
    |}>,
  |},
  +states: $ReadOnlyArray<{|
    +id: string,
    +isEnabled: boolean,
    +status: JobStateStatus,
    +workflowState: {|
      +id: string,
      +name: string,
      +type: ?WorkflowStateType,
    |},
  |}>,
  +$refType: WorkflowUtils_job$ref,
|};
export type WorkflowUtils_job$data = WorkflowUtils_job;
export type WorkflowUtils_job$key = {
  +$data?: WorkflowUtils_job$data,
  +$fragmentRefs: WorkflowUtils_job$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v3 = [
  (v0/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "WorkflowUtils_job",
  "type": "Job",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "workflow",
      "storageKey": null,
      "args": null,
      "concreteType": "Workflow",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "states",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkflowState",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isRequired",
              "args": null,
              "storageKey": null
            },
            (v2/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "transitions",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkflowTransition",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "toWorkflowState",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkflowState",
              "plural": false,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "fromWorkflowState",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkflowState",
              "plural": false,
              "selections": (v3/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "states",
      "storageKey": null,
      "args": null,
      "concreteType": "JobState",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isEnabled",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "workflowState",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkflowState",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '72dcad6fb261642331f51443a17add68';
module.exports = node;
